export default {
  sm: `
  LEED certificate is a world-class eco-
  friendly building certification system that 
  assesses on the eco-friendly efforts that 
  went into the entire process of a building's 
  architecture, from the selection of the 
  building site to planning, building, and 
  operation of the building.
  `,
  lg: `
  LEED certificate is a world-class eco-friendly 
  building certification system that assesses on the 
  eco-friendly efforts that went into the entire 
  process of a building's architecture, from the 
  selection of the building site to planning, building, 
  and operation of the building.
  `,
  xxl: `
  LEED certificate is a world-class eco-friendly building certification
  system that assesses on the eco-friendly efforts that went into the 
  entire process of a building's architecture, from the selection of the 
  building site to planning, building, and operation of the building.
  `
};
